/**
 * Created by shahar on 11-Jul-16.
 */
import {Order} from "../../order/models/order";
import {ALookupRowsContainer} from "../../order/models/lookup.rows.container";

export class Insurer extends ALookupRowsContainer{
	insurerKey: number;
	visitKey: number;
	companyName:string;
	companyContactPerson: string;
	companyPhoneNumber: string;
	companyStreetAddress: string;
	companyCity: string;
	companyProvince: string;
	companyCountry: string;
	companyPostalCode: string;
	coordOfBenPriority: number;
	policyNumber: string;
	payorKey: number;
	insuredRelationshipKey: number;
	insuredMemberId: string;

	get companyAddress() {
		return this.FKLookupRows.payorKey?this.FKLookupRows.payorKey.address:"";
		//return this.companyStreetAddress;
	}

}
/**
 * actual class for a visit, including functions.
 * this class should somehow by dynamically extended in the future - for now
 * we have some static methods on it and in the future we will enable dynamic extensions for it
 */
export class Visit  extends ALookupRowsContainer{
	static orders_TYPE;
	static insurer_TYPE;

	patientClass:string;
	patientClassKey:number;
	visitNumber: string;
	visitKey: number;
	admitDateTime: Date;

	insurer: Insurer[];
	/* tslint:disable */
	FKLookupRows:any;
	/* tslint:enable */

	orders: Order[];

	get firstOrder() { return this.orders ? this.orders[0] : {}; }
	get firstInsurer() {
		let prop = 'insurer';
		if (!this[prop] || !this[prop][0]) {
			this[prop] = [new Insurer()];
		}
		return this[prop][0];
	}
}
Visit.orders_TYPE = Order;
Visit.insurer_TYPE = Insurer;


export class VisitUI extends Visit {
	isNewVisit?: boolean;
	visitDescription? : string;
}
